import React from 'react';
import PropTypes from 'prop-types';
// Material UI
import { makeStyles } from '@material-ui/core/styles';
import MuiBackdrop from '@material-ui/core/Backdrop';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.tooltip + 1,
  },
}));

const Backdrop = ({ open, invisible, children }) => {
  const classes = useStyles();
  const backdropProps = { open, invisible };
  return (
    <MuiBackdrop className={classes.backdrop} {...backdropProps}>
      { children }
    </MuiBackdrop>
  );
};

Backdrop.propTypes = {
  open: PropTypes.bool.isRequired,
  invisible: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
};

export default React.memo(Backdrop);



// WEBPACK FOOTER //
// ./components/core/Backdrop.js